import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Badge Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * HTML Tag
     */
    @Prop({ default: 'span' }) tag!: string;

    /**
     * Make the one side Sharp
     */
    @Prop({ type: String }) oneSideSharp!: string;

    /**
     * Reverse color
     */
    @Prop({ type: Boolean }) reverse!: boolean;

    /**
     * Ignore content and set border-radius: 50%
     */
    @Prop({ type: Boolean }) dot!: boolean;
}

export default Props;
